<script lang="ts">
  // @ts-expect-error FIXME: svelte-router-spa does not have types
  import { Router, type Route } from "svelte-router-spa";
  import Layout from "./components/Layout.svelte";
  import TopBar from "./components/TopBar.svelte";
  import Footer from "./components/Footer.svelte";
  import { buildRoutes } from "./lib/routing";
  import { onMount } from "svelte";
  import { initMicrosite } from "./lib/core";
  import LoadingScreen from "./components/LoadingScreen.svelte";
  import { modeStore, isEditorMode } from "./lib/stores/mode";
  import { setupEditorMode } from "./lib/helpers/editor";
  import { getCopy } from "./lib/stores/copy";
  import ProgressBar from "./components/Progress/ProgressBar.svelte";
  import CustomHtml from "./components/CustomHTML.svelte";

  let routes: Route[] = [];
  let isLoading = true;

  onMount(async () => {
    try {
      await initMicrosite();
      routes = buildRoutes();

      if (isEditorMode()) {
        setupEditorMode();
      }
    } catch (error) {
      // we need to build the routes even when there's an error
      // so that we can show the proper error page
      routes = buildRoutes();
      console.error("Error loading microsite settings ...");
    }

    isLoading = false;
  });

  $: title = $getCopy("title", { basePath: "" }) as string;
  $: headScripts = ($getCopy("scripts") as Record<string, string>).head;
  $: bodyScripts = ($getCopy("scripts") as Record<string, string>).body;
</script>

<svelte:head>
  <title>{title}</title>
  <CustomHtml isHeadElement={true} customHtml={headScripts} />
</svelte:head>

<Layout>
  <svelte:fragment slot="bodyScripts">
    <CustomHtml customHtml={bodyScripts} />
  </svelte:fragment>
  <svelte:fragment slot="header">
    <TopBar />
    <ProgressBar />
  </svelte:fragment>
  <svelte:fragment slot="content">
    {#if $modeStore.mode !== "live"}
      <div class="fixed bottom-0 right-0 p-4 text-white bg-red-600 z-50">
        <strong>{$modeStore.mode.toUpperCase()} MODE</strong>
      </div>
    {/if}
    {#if isLoading}
      <div class="pt-64">
        <LoadingScreen />
      </div>
    {:else}
      <Router {routes} />
    {/if}
  </svelte:fragment>
  <Footer slot="footer" />
</Layout>
